import React from "react";
import boxiaCircleLogo from "../assets/images/Boxia Circle Main.png";
import { Github, Twitter, Linkedin } from "lucide-react";

const Footer = ({ darkMode }) => {
  const footerSections = [
    {
      title: "Product",
      items: [
        { name: "Features", href: "/features" },
        { name: "Pricing", href: "/pricing" },
        { name: "Integrations", href: "/integrations" },
        // { name: "Security", href: "/security" },
        // { name: "Enterprise", href: "/enterprise" },
      ],
    },
    // {
    //   title: "Company",
    //   items: [
    //     { name: "About Us", href: "#about" },
    //     { name: "Careers", href: "#careers" },
    //     { name: "Blog", href: "#blog" },
    //     { name: "Press Kit", href: "#press" },
    //     { name: "Contact", href: "#contact" },
    //   ],
    // },
    // {
    //   title: "Resources",
    //   items: [
    //     { name: "Documentation", href: "#docs" },
    //     { name: "API Reference", href: "#api" },
    //     { name: "Tutorials", href: "#tutorials" },
    //     { name: "Status", href: "#status" },
    //     { name: "Support", href: "#support" },
    //   ],
    // },
    {
      title: "Legal",
      items: [
        { name: "Privacy Policy", href: "/privacy" },
        { name: "Terms of Service", href: "https://app.boxia.io/terms" },
        // { name: "Cookie Policy", href: "/cookies" },
        // { name: "GDPR", href: "/gdpr" },
        // { name: "Security", href: "/security" },
      ],
    },
  ];

  return (
    <footer className="relative">
      <div className="absolute inset-0 z-[0] bg-purple-950/10 dark:bg-purple-950/10 bg-[radial-gradient(ellipse_20%_80%_at_50%_-20%,rgba(120,119,198,0.15),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_20%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))]" />
      <div className="relative z-10 mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:gap-12">
          {footerSections.map((section) => (
            <div key={section.title} className="space-y-4">
              <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.items.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-black/5 dark:border-white/5">
          <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
            <div className="flex items-center space-x-4">
              <img
                src={boxiaCircleLogo}
                alt="Boxia Logo"
                className="h-8 w-8 rounded-lg"
              />
              <div className="space-y-1">
                <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
                  Boxia
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  The Future of Work
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-6">
              <a
                href="https://github.com/Boxia-io"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="https://twitter.com/getboxia"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="https://linkedin.com/company/boxiaio"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div className="mt-8 flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              © {new Date().getFullYear()} Boxia. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="/privacy"
                className="text-sm text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                Privacy
              </a>
              <div className="h-1 w-1 rounded-full bg-gray-600 dark:bg-gray-400" />
              <a
                href="https://app.boxia.io/terms"
                className="text-sm text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                Terms
              </a>
              {/* <div className="h-1 w-1 rounded-full bg-gray-600 dark:bg-gray-400" />
              <a
                href="#"
                className="text-sm text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors duration-300"
              >
                Cookies
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
